// extracted by mini-css-extract-plugin
export default {"WelcomePageSectionFrame":"WelcomePageFromeLogIn_WelcomePageSectionFrame__p95ot"};